import * as React from 'react';
import { useSpring } from 'react-spring';
import { usePrefersReducedMotion } from '../use-prefers-motion/UsePrefersMotion';
import CSS from 'csstype';

export type UseAnimationProps = {
    rotation?: number;
    scale?: number;
    tension?: number;
    friction?: number;
    timing?: number;
    x?: number;
    y?: number;
};

export const useAnimation = (props: UseAnimationProps): [CSS.Properties, () => void] => {
    const { x, y, rotation, scale, tension, friction, timing } = props;
    const prefersReducedMotion = usePrefersReducedMotion();
    const [isBooped, setIsBooped] = React.useState(false);

    const style = useSpring({
        transform: isBooped
            ? `translate(${x}px, ${y}px)
         rotate(${rotation}deg)
         scale(${scale})`
            : `translate(0px, 0px)
         rotate(0deg)
         scale(1)`,
        config: { tension, friction },
    });

    React.useEffect(() => {
        if (!isBooped) {
            return;
        }
        const timeoutId = window.setTimeout(() => {
            setIsBooped(false);
        }, timing);
        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [isBooped]);
    const trigger = React.useCallback(() => {
        setIsBooped(true);
    }, []);
    const appliedStyle = prefersReducedMotion ? {} : style;
    return [appliedStyle, trigger];
};

useAnimation.defaultProps = {
    x: 0,
    y: 0,
    rotation: 0,
    scale: 1,
    timing: 150,
    tension: 300,
    friction: 10,
};
